var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3437_794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0687 15.4531L24.2698 25.7534H21.3145L15.4381 17.3484V17.3478L14.5754 16.114L7.71094 6.29492H10.6663L16.2059 14.2193L17.0687 15.4531Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5423 0H3.45767C1.5481 0 0 1.5481 0 3.45767V28.5423C0 30.4519 1.5481 32 3.45767 32H28.5423C30.4519 32 32 30.4519 32 28.5423V3.45767C32 1.5481 30.4519 0 28.5423 0ZM20.4106 27.1366L14.4642 18.4823L7.01914 27.1366H5.09496L13.6098 17.2393L5.09496 4.84694H11.5894L17.2203 13.042L24.2702 4.84694H26.1944L18.0749 14.2852H18.0744L26.905 27.1366H20.4106Z",
    fill: "#20ACE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3437_794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5d31fc24fe9a95315fced77850726e35.svg";
export { ForwardRef as ReactComponent };